module.exports = __webpack_public_path__ + "img/icon-xarvioV2.3850254d.png";